/**
 * @description 프로젝트에서 사용하는 파일 종류를 정의
 * API 요청 시 키와 같아야함
 */
export var FILE_CATEGORY;
(function (FILE_CATEGORY) {
    FILE_CATEGORY["\uC218\uC785\uAC80\uC0AC\uC11C"] = "receivingInspection";
    FILE_CATEGORY["\uC2DC\uD5D8\uC131\uC801\uC11C"] = "inspectionReport";
    FILE_CATEGORY["\uC2B9\uC778\uC11C"] = "approval";
    FILE_CATEGORY["\uB3C4\uBA74"] = "blueprint";
    FILE_CATEGORY["\uC218\uC8FC\uC11C"] = "obtain";
    FILE_CATEGORY["\uAE30\uD0C0"] = "etcFiles";
    FILE_CATEGORY["\uAD6C\uB9E4\uACAC\uC801\uC11C"] = "purchaseEstimate";
    FILE_CATEGORY["\uBC1C\uC8FC\uC11C"] = "order";
    FILE_CATEGORY["\uBC1C\uC8FC\uD655\uC778\uC11C"] = "orderConfirmation";
    FILE_CATEGORY["\uBC1C\uC8FC\uCC98\uC0AC\uC5C5\uC790\uB4F1\uB85D\uC99D"] = "businessRegistration";
    FILE_CATEGORY["\uBC1C\uC8FC\uCC98\uD1B5\uC7A5\uC0AC\uBCF8"] = "bankbook";
})(FILE_CATEGORY || (FILE_CATEGORY = {}));
